export default "__VITE_ASSET__63920ebc__"